// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1203":"1e9f2d72553775be","6402":"6ef970964cedec93","9894":"c61ed7522ffc7b47"}[chunkId] + ".js";
};